import React, { memo } from 'react';
import { Button } from 'components';

interface FilterButtonProps {
  label: string;
  count: number;
  isSelected: boolean;
  onClick: () => void;
}

export const FilterButton = memo(({ label, count, isSelected, onClick }: FilterButtonProps) => {
  return (
    <Button className={isSelected ? 'selected' : ''} onClick={onClick}>
      {label} ({count})
    </Button>
  );
});
